import type { TooltipProps } from "primereact/tooltip";

/**
 * Props padrão das tooltips de ação do Hub (`<Tooltip target=… {...actionTooltipProps("Editar")} />`):
 * texto acima do ícone, aberto por hover e foco; a aparência vem do tema Prime (`.p-tooltip`, frame `tooltip`).
 */
export function actionTooltipProps(
  label: string,
  overrides: Partial<TooltipProps> = {},
): TooltipProps {
  return { content: label, position: "top", event: "both", ...overrides };
}
